import { AnswerModel } from './answer.model';

export class IndicateurModel
{


	id: number = undefined;
	name: string = undefined;
	description: string = undefined;
	gravities: any[] = [];
	evolutions: string[] = [];
	preco: any = undefined;

	/* ************************* 
	* multichoicegravity role has change. It is now an indicator mode, influencing gravity and score
	*  0 : exclusive mode (only one choice for gravity)
	*  1 : additive mode (several choices for gravity, each choice increase gravity score)
	* -1 : soustractive mode (several choices for gravity, each choice decrease gravity score)
	*-10 : no scoring (this indicator does not count to calculate global score and note)
	*/
	multichoicegravity: number = 0;
	
	weighting: number = 1;
	ordre: number = 0;

	IndiGroupId:number = undefined;
	buildingType_add = [];
	buildingType_remove = [];


	answer:AnswerModel = new AnswerModel({});


	constructor(values: Object = null) {
		/* CONST */
		let nbGravities: number = 5;
		let nbEvolutions: number = 5;

		for(let g=0; g<nbGravities; g++) {
			this.gravities[g] = '';
		}
		for(let e=0; e<nbEvolutions; e++) {
			this.evolutions[e] = '';
		}
	   if(values) this.exchange(values);
	}

	exchange(values: Object = {}) {
		for (let p in values) {
		    if (this.hasOwnProperty(p) && values.hasOwnProperty(p)) {
		    	if(p == 'id' && this.id != undefined) {
		    		continue;
		    	}
		    	if(p=='gravities') {
		    		if(typeof values[p][0] == 'string') {
		    			values[p].forEach((g, i)=>{
		    				this[p][i] = {
		    					'label': g,
		    					'weight': ( (values['multichoicegravity']==0) ? (i+1) : 1 )
		    				};
		    			});
		    		} else {
		    			this[p] = values[p];
		    		}
		    	} else if(p=='answer') {
		    		this.answer.exchange(values[p]);
		    	} else {
		    		this[p] = values[p];
		    	} 
		    }
		}

		this.answer.indicatorDefaults = {
			weighting: this.weighting,
			multichoicegravity: this.multichoicegravity,
			gravities: this.gravities,
		}
	}
}